
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/me",
      function () {
        return require("private-next-pages/profile/me/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/me"])
      });
    }
  